import { render, staticRenderFns } from "./ViaEmilia.vue?vue&type=template&id=13aed922&"
import script from "./ViaEmilia.vue?vue&type=script&lang=js&"
export * from "./ViaEmilia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports